import { VNode } from 'vue'
import { DirectiveBinding } from 'vue/types/options'

type CustomElement = HTMLElement & {
	['clickOutsideEvent']: (event: Event) => void,
}

export default {
	bind(elOriginal: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
		const el = elOriginal as CustomElement
		el.clickOutsideEvent = (event: Event) => {
			if (
				el === event.target ||
				el.contains(event.target as Node | null) ||
				!binding.value
			) return
			binding.value.bind(vnode)(event)
		}
		document.body.addEventListener('click', el.clickOutsideEvent)
		document.body.addEventListener('touchstart', el.clickOutsideEvent)
	},
	unbind(elOriginal: HTMLElement & CustomElement) {
		const el = elOriginal as CustomElement
		document.body.removeEventListener('click', el.clickOutsideEvent)
		document.body.removeEventListener('touchstart', el.clickOutsideEvent)
	},
}
